import React from 'react';

import StyledInputBlock from '+/styledComponents/StyledInputBlock';
import StyledRow from '+/styledComponents/StyledRow';

import PropTypes from '../instances/propTypesInstance';

export const Field = ({
  name,
  label = '',
  half = false,
  note = '',
  values,
  errors,
  handleChange,
  handleBlur,
  touched,
  disabled = false,
  submitCount,
  options = [],
  tooltip = null,
  fieldType = 'text',
  ...props
}) => (
  <StyledRow key={name} halfWidth={half} className={name}>
    <StyledInputBlock
      {...props}
      values={values}
      errors={errors}
      name={name}
      label={label}
      handleChange={handleChange}
      handleBlur={handleBlur}
      touched={touched}
      submitCount={submitCount}
      disabled={disabled}
      note={note}
      options={options}
      tooltip={tooltip}
      fieldType={fieldType}
    />
  </StyledRow>
);

Field.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  half: PropTypes.bool,
  note: PropTypes.string,
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  touched: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.arrayOf(PropTypes.object),
  tooltip: PropTypes.node,
  submitCount: PropTypes.number.isRequired,
  fieldType: PropTypes.string,
};
